(function () {
  var AUTOPLAY_DELAY = 5000;
  var VISIBILITY_THRESHOLD = 0.35;

  var roots = document.querySelectorAll('[data-eco-home-campaigns]');

  roots.forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eco-home-slide]'));
    var prevButton = root.querySelector('[data-eco-home-campaigns-prev]');
    var nextButton = root.querySelector('[data-eco-home-campaigns-next]');
    var section = root.closest('.eco-home-campaigns');
    var progress = section ? section.querySelector('[data-eco-home-campaigns-progress]') : null;

    if (!slides.length) return;

    var currentIndex = 0;
    var autoplayTimer = null;
    var hasStartedAutoplay = false;
    var isSectionVisible = false;

    /* Cria os indicadores de progresso */
    if (progress) {
      progress.innerHTML = '';

      slides.forEach(function () {
        var item = document.createElement('span');
        progress.appendChild(item);
      });
    }

    function getProgressItems() {
      if (!progress) return [];
      return Array.prototype.slice.call(progress.querySelectorAll('span'));
    }

    function resetProgressAnimation() {
      var items = getProgressItems();

      items.forEach(function (item) {
        item.classList.remove('is-active');
        void item.offsetWidth;
      });

      if (items[currentIndex]) {
        items[currentIndex].classList.add('is-active');
      }
    }

    function showSlide(index, shouldResetTimer) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      currentIndex = index;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });

      resetProgressAnimation();

      if (shouldResetTimer && isSectionVisible) {
        restartAutoplay();
      }
    }

    function nextSlide() {
      showSlide(currentIndex + 1, false);
    }

    function previousSlide() {
      showSlide(currentIndex - 1, false);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (autoplayTimer) return;

      hasStartedAutoplay = true;

      resetProgressAnimation();

      autoplayTimer = setInterval(function () {
        nextSlide();
      }, AUTOPLAY_DELAY);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        previousSlide();
        restartAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        nextSlide();
        restartAutoplay();
      });
    }

    /* Estado inicial: mostra o primeiro slide, mas NÃO inicia o autoplay */
    showSlide(0, false);
    stopAutoplay();

    /*
      Inicia a rolagem automática apenas quando a seção entra na tela.
      Enquanto o usuário não chegar nos banners, o carrossel permanece parado.
    */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isSectionVisible = entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD;

          if (isSectionVisible) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      }, {
        threshold: [0, VISIBILITY_THRESHOLD, 0.6, 1]
      });

      observer.observe(root);
    } else {
      /*
        Fallback para navegadores antigos:
        verifica a posição da seção no scroll.
      */
      function checkVisibilityFallback() {
        var rect = root.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        var visibleRatio = visibleHeight / Math.max(rect.height, 1);

        isSectionVisible = visibleRatio >= VISIBILITY_THRESHOLD;

        if (isSectionVisible) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      }

      window.addEventListener('scroll', checkVisibilityFallback, { passive: true });
      window.addEventListener('resize', checkVisibilityFallback);
      checkVisibilityFallback();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else if (isSectionVisible && hasStartedAutoplay) {
        startAutoplay();
      }
    });
  });
})();